// extracted by mini-css-extract-plugin
export default {"filter-actions":"incident_filter-actions__wvjHF","item-width":"incident_item-width__2m6JM"};